const { BANK_TRANSFER_REQUEST_STATUS } = require('arbitrip-common/general/constants');

const CONSTANTS = module.exports = {};

CONSTANTS.BANK_TRANSFER_BUSINESS_DAYS_BEFORE_DEADLINE = 4;

CONSTANTS.BANK_TRANSFER_MAX_FILE_SIZE_BYTES = 10 * 1024 * 1024; // 10 MB per file
CONSTANTS.BANK_TRANSFER_MAX_FILES = 10; // not a stated business rule — just a sane abuse-prevention cap
CONSTANTS.BANK_TRANSFER_ALLOWED_MIME_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];

// AR-3494 — the BankTransferRequest statuses that block: a request in any of
// these is "open or completed", so the money is either in flight or
// settled. Only CANCELLED is non-blocking — CANCELLED_PENDING_REVIEW is an
// agent-initiated transition that Finance has not yet reviewed, so the lock
// holds until Finance confirms the cancellation (013-BE).
// Consumed by: packages/mongodb/bank-transfer-lock.js (commission lock,
// AR-3494) and frontend/web .../new-bookings/utils/eligibility.js
// (pay-selection eligibility, 016-FE).
CONSTANTS.LOCKING_BANK_TRANSFER_REQUEST_STATUSES = [
    BANK_TRANSFER_REQUEST_STATUS.SUBMITTED,
    BANK_TRANSFER_REQUEST_STATUS.NEEDS_CORRECTION,
    BANK_TRANSFER_REQUEST_STATUS.CANCELLED_PENDING_REVIEW,
    BANK_TRANSFER_REQUEST_STATUS.PAID,
];

// AR-3648 — the WIRE values `/finance/mark-as-paid` accepts and
// `payments.manually_marked_paid_method` stores verbatim. All three are real
// operator choices (the Finance dialog offers exactly these), and the split
// between the two card methods is load-bearing: `payment_type` collapses both
// to `credit_card`, so this field is the ONLY place CREDIT_CARD_LINK stays
// distinguishable from CREDIT_CARD after the write.
//
// The key `PAYMENT_LINK` is a server-side name; its wire value is
// `CREDIT_CARD_LINK`. Mirrored by `MARK_AS_PAID_PAYMENT_METHOD` in
// `packages/bank-transfer/src/finance/constants.ts` (which pins its own
// literals, per that unit's byte-parity convention) and by the zod enum in
// `frontend/trader-2.0/src/features/arbitrip/finance/schema.ts`. Keep the
// three in step.
CONSTANTS.MARK_AS_PAID_PAYMENT_METHOD = {
    BANK_TRANSFER: 'BANK_TRANSFER',
    CREDIT_CARD: 'CREDIT_CARD',
    PAYMENT_LINK: 'CREDIT_CARD_LINK',
};

// AR-3494 (015-BE) — canonical, cross-service copy of the commission-lock
// error contract. `services/trader-api-2.0` pins its OWN literal copy of
// this string in `update.constants.ts` deliberately (that unit's byte-parity
// migration convention — see that file's header comment — pins wire-strings
// rather than re-deriving them at runtime), so it is not changed to import
// this one. This export exists so `services/trader-api` (the legacy route,
// a separate deployable service that cannot require TS from trader-api-2.0)
// has a real shared source instead of retyping the literal — both services
// already depend on `@arbitrip/constants`. Keep the string byte-identical to
// `services/trader-api-2.0/src/routes/reservations/update.constants.ts`'s
// `MSG_BANK_TRANSFER_COMMISSION_LOCKED` if either ever changes.
CONSTANTS.MSG_BANK_TRANSFER_COMMISSION_LOCKED =
    'Commission is locked because an active bank transfer request exists for this reservation';

// AR-3494 (015-BE) — the FLAT (scalar) commission-driving field keys that
// trigger the bank-transfer lock guard on key presence alone. Mirrors
// trader-api-2.0's `BANK_TRANSFER_LOCKED_FLAT_FIELD_KEYS` (012-BE) exactly;
// `deal` is intentionally excluded here too — the legacy route's guard
// checks `deal` separately via a value comparison against the stored
// document (see `services/trader-api/routes/arbitrip.js`, `dealPricingChanged`).
CONSTANTS.LOCKED_COMMISSION_FLAT_FIELD_KEYS = ['client_currency', 'client_price', 'sell_price'];
